import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
// import {FacetimeStatusType, WorkLevelEnum, WorkLevelType} from './constant'

// [七日心动之旅——详情页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127597270
export const love_journey_7days_detail_page = createAsyncThunk(
  'LoveJourney/live/facetime/love_journey_7days_detail_page',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<DetailRes>>(
      '/live/facetime/love_journey_7days_detail_page',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [七日心动之旅——挑战成功页面] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127597446
export const love_journey_7days_complete_page = createAsyncThunk(
  'LoveJourney/live/facetime/love_journey_7days_complete_page',
  async (arg: {peer_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<CompleteRes>>(
      '/live/facetime/love_journey_7days_complete_page',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface GiftExhibition {
  title: string // 礼物展示模块的小标题
  gift_pictures: string[] // 列表,内存七天礼物的图片url
}

interface CompleteRes {
  err_msg: string // 异常的错误说明
  title: string // 标题
  regulation: string // 规则入口文案
  description: string // 提示文案
  view_details: string // 返回入口文案
  gifts_exhibition: GiftExhibition // 礼物展示模块
  final_rewards: LongRelationShip7DaysFinalRewardV2 // 终极奖励展示模块
}
interface LongRelationShip7DaysFinalRewardV2 {
  title: string
  rewards: {
    picture: string
    describe: string
    super_script: string
  }[]
}

export enum StatusEnum {
  未解锁 = 0,
  已解锁,
  已点亮,
}

// [视频打赏商品 GoodsInfo] http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390158
interface GoodsInfo {
  goods_id: number // 商品Id
  name: string // 商品名
  cost: number // 价格
  cost_display: number
  url: string // 礼物封面图片
  thumb_url: string // 礼物缩略图
}
interface TaskRewardInfo {
  day: number // 进度提示--【2 days】
  goods_info: GoodsInfo
  status_code: StatusEnum // 卡片状态: 0-未解锁、1-已解锁、2-已点亮
  expire_timestamp: number // 过期的时间戳，秒级，unix时间，用于前端的倒计时
}
interface LongRelationShip7DaysTaskReward {
  cursor: number // 当前是本轮次中的第几天
  task_reward: TaskRewardInfo[] // 礼物信息
}

interface LongRelationShip7DaysFinalReward {
  describe: string // 描述文案
  title: string // 标题文案
  rewards: {
    pictures: string[] // 奖励图片的url
    describe: string // 奖励文案
    super_script: string // 上标
  }[]
}

interface DetailRes {
  err_msg: string // 异常的错误说明
  title: string // 标题
  regulation: string // 规则入口文案
  describe: string // 描述文案
  round_complete: boolean // 本轮连续7天送礼是否已经完成，完成（true）的话请直接调用【挑战成功页面】接口
  final_rewards: LongRelationShip7DaysFinalReward // 终极限定奖励
  task_reward: LongRelationShip7DaysTaskReward // 详情页中的七张卡片
  mid_pair: string // 用于match_action埋点
}

export interface InitialStateType {
  detail: Partial<DetailRes>
  complete: Partial<CompleteRes>
}

const initialState: InitialStateType = {
  detail: {},
  complete: {},
}

export const LoveJourneySlice = createSlice({
  name: 'LoveJourney',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      love_journey_7days_detail_page.fulfilled,
      (state, action) => {
        Object.assign(state, {detail: {...action.payload}})
      }
    )
    builder.addCase(
      love_journey_7days_complete_page.fulfilled,
      (state, action) => {
        Object.assign(state, {complete: {...action.payload}})
      }
    )
  },
})
export default LoveJourneySlice.reducer
export const LoveJourneyActions = LoveJourneySlice.actions

export const useLoveJourneyDetailState = () => {
  const data = useSelector((state) => {
    return state.LoveJourney.detail
  })
  return data
}

export const useLoveJourneyCompleteState = () => {
  const data = useSelector((state) => {
    return state.LoveJourney.complete
  })
  return data
}
